import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import styles from '../ManagerDashboard/Profile.module.css';

const CustomModal = ({ title, message, onClose }) => {
  if (!title) return null;
  
  return (
    <div className={styles['modal-overlay']}>
      <div className={styles['modal-content']}>
        <button className={styles['modal-close']} onClick={onClose}>
          <FontAwesomeIcon icon={faTimes} />
        </button>
        <h2>{title}</h2>
        <p>{message}</p>
        <div className={styles['form-actions']}>
          <button 
            className={styles['primary-button']} 
            onClick={onClose}
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default CustomModal;